import { webSocketsRepository } from '@bg-shared/infrastructure/WebSockets';
import { IGenericDraw } from '@bg-shared/interfaces/Draws/IGenericDraw';
import { IGameBlackjackDraw } from '@bg-shared/interfaces/Draws/IBlackjackDraw';
import { GameId } from '@bg-shared/enums/GameId';
import { IGamesService } from './interfaces';

class GamesService implements IGamesService {
    public getGamesData(games: Array<{ gameId: GameId; presetId: number }>, taxSchemeID: number) {
        const params = games.map((game) => ({
            gameID: game.gameId,
            presetID: game.presetId,
            taxSchemeID,
        }));

        return new Promise<Record<GameId, IGenericDraw>>((resolve) => {
            webSocketsRepository.emit<Record<GameId, IGenericDraw>>(
                'games-info',
                params,
                (data) => {
                    resolve(data);
                },
            );
        });
    }

    public getPLSGamesData(gameIds: GameId[]) {
        if (!gameIds.length) {
            return Promise.resolve(null);
        }

        const params = {
            gameIDs: gameIds,
        };

        return new Promise((resolve) => {
            webSocketsRepository.emit<Record<GameId, IGameBlackjackDraw>>(
                'pls-games-info',
                params,
                (data) => {
                    resolve(data);
                },
            );
        });
    }
}

export const gamesService = new GamesService();
